import { render } from "./teamticket.vue?vue&type=template&id=ec65f58a"
import script from "./teamticket.vue?vue&type=script&lang=js"
export * from "./teamticket.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__